import React from 'react';
import PropTypes from 'prop-types';
import { ADD_ONS } from '../constants';

const addOnsSVG = (option, label) => {
  switch (option) {
    case ADD_ONS.CLAMPS:
      return (
        <>
          <span>{label.CLAMPS}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.CLAMPS}</title>
            <path className="bg" d="m55.36 108.11h89.2v8.07h-89.2z" />
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-63.5 50.1h44v9.6h-14.11v11.1h-15.73v-11.1h-14.16zm-96.13 0h44v9.6h-14.11v11.1h-15.76v-11.1h-14.1zm144.92 47.51h-23.3v8.07h23.33v16.53h-23.33v6.69h-6.93v-6.69h-89.2v6.69h-6.93v-6.69h-25.86v-16.53h25.86v-8.07h-25.86v-16.53h25.86v-4.44h6.93v4.44h89.2v-4.44h6.93v4.44h23.33z"
            />
          </svg>
        </>
      );
    case ADD_ONS.DATA_LOGGING:
      return (
        <>
          <span>{label.DATA_LOGGING}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.DATA_LOGGING}</title>
            <g className="bg">
              <rect height="7.94" rx="2.65" width="7.94" x="135.74" y="139.82" />
              <path d="m55 120v31.78a2.64 2.64 0 0 0 2.65 2.64h60.89v-37.1h-60.9a2.64 2.64 0 0 0 -2.64 2.68z" />
              <path d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-113.62 35.05c0-4.34 10.8-7.88 24.12-7.88s24.12 3.54 24.12 7.88v4.92c0 4.34-10.8 7.88-24.12 7.88s-24.12-3.54-24.12-7.88zm0 11.07c5.18 3.57 14.67 5.23 24.12 5.23s18.94-1.66 24.12-5.23v11.08c0 4.34-10.8 7.87-24.12 7.87s-24.12-3.57-24.12-7.87zm0 17.23c5.18 3.57 14.67 5.23 24.12 5.23s18.94-1.66 24.12-5.23v11.08c0 4.33-10.8 7.87-24.12 7.87s-24.12-3.54-24.12-7.87zm77.12 80.53a2.64 2.64 0 0 1 -2.64 2.65h-23.88v2.65a2.65 2.65 0 0 1 -2.65 2.65h-66.19a10.59 10.59 0 0 1 -10.59-10.59v-31.74a10.59 10.59 0 0 1 10.59-10.59h66.19a2.65 2.65 0 0 1 2.65 2.65v2.65h23.83a2.64 2.64 0 0 1 2.64 2.65z" />
              <rect height="7.94" rx="2.65" width="7.94" x="135.74" y="123.94" />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.IN_FRAME:
      return (
        <>
          <span>{label.IN_FRAME}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.IN_FRAME}</title>
            <g className="bg">
              <path d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-8 77.12h-11.26v24.78h11.22v38a9.09 9.09 0 0 1 -9.09 9.09h-2.13v3.72h-18.12v-3.72h-105.28v3.72h-18.11v-3.72h-1.1a9.09 9.09 0 0 1 -9.09-9.09v-38h10.19v-24.78h-10.19v-38a9.08 9.08 0 0 1 9.09-9.08h1.1v-10.38h18.11v10.41h105.28v-10.41h18.12v10.41h2.13a9.08 9.08 0 0 1 9.09 9.08z" />
              <path d="m46.84 112.4h105.28v-24.78h-105.28zm8.32-17h89.68v2.92h-89.68zm89.68 6.24v2.92h-89.68v-2.92z" />
              <path d="m52.68 149.43h93v-26.63h-93zm68.91-6.32a2.8 2.8 0 1 1 2.79-2.8 2.8 2.8 0 0 1 -2.79 2.8zm7.87 0a2.8 2.8 0 1 1 2.8-2.8 2.8 2.8 0 0 1 -2.8 2.8zm7.81 0a2.8 2.8 0 1 1 2.79-2.8 2.81 2.81 0 0 1 -2.79 2.8zm-18.54-14.27h21.33v6.16h-21.33zm-40 0h34.07v14.56h-34.04zm-17.73 1.64 3.9 6.75 2.1-1.23-3.88-6.74a7.28 7.28 0 1 1 -4.79 6.84 7.23 7.23 0 0 1 2.67-5.62z" />
              <path d="m145.68 50.57h-93v26.63h93zm-80.09 20.59a7.28 7.28 0 0 1 -4.59-12.92l3.89 6.76 2.11-1.22-3.9-6.73a7.27 7.27 0 1 1 2.49 14.11zm47.24 0h-34.07v-14.55h34.07zm8.76-.29a2.8 2.8 0 1 1 2.79-2.79 2.79 2.79 0 0 1 -2.79 2.79zm7.87 0a2.8 2.8 0 1 1 2.8-2.79 2.79 2.79 0 0 1 -2.8 2.79zm7.81 0a2.8 2.8 0 1 1 2.79-2.79 2.8 2.8 0 0 1 -2.79 2.79zm2.79-8.1h-21.33v-6.16h21.33z" />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.MULTI_PLATEN:
      return (
        <>
          <span>{label.MULTI_PLATEN}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.MULTI_PLATEN}</title>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.89999 0 50.89999 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.89999 0 50.89999-10.5 61.5-10.60001 10.5-27.60001 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.60001-10.5-27.60001-10.5-61.5z"
            />
            <g style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#fff' }}>
              <path d="m101 132h66v-64h-66zm58-62h5v5h-5zm0 14h5v5h-5zm0 13.5h5v5h-5zm0 13.5h5v5h-5zm0 14h5v5h-5zm-14-55h5v5h-5zm0 55h5v5h-5zm-14-55h5v5h-5zm0 55h5v5h-5zm-13-55h5v5h-5zm0 55h5v5h-5zm-14-55h5v5h-5zm0 14h5v5h-5zm0 13.5h5v5h-5zm0 13.5h5v5h-5zm0 14h5v5h-5z" />
              <path d="m33 132h66v-64h-66zm58-62h5v5h-5zm0 14h5v5h-5zm0 13.5h5v5h-5zm0 13.5h5v5h-5zm0 14h5v5h-5zm-14-55h5v5h-5zm0 55h5v5h-5zm-14-55h5v5h-5zm0 55h5v5h-5zm-13-55h5v5h-5zm0 55h5v5h-5zm-14-55h5v5h-5zm0 14h5v5h-5zm0 13.5h5v5h-5zm0 13.5h5v5h-5zm0 14h5v5h-5z" />
              <path d="m28 63v74h144v-74zm141 5v64 2h-2-66-2-66-1-1v-68h1 1 66 2 66 2z" />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.PUMP_RECEPTACLE:
      return (
        <>
          <span>{label.PUMP_RECEPTACLE}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.PUMP_RECEPTACLE}</title>
            <path
              className="bg"
              d="m189.5 10.5c-10.6-10.5-27.6-10.5-61.5-10.5h-56c-33.9 0-50.9 0-61.5 10.5s-10.5 27.6-10.5 61.5v56c0 33.9 0 50.9 10.5 61.5s27.6 10.5 61.5 10.5h56c33.9 0 50.9 0 61.5-10.5s10.5-27.6 10.5-61.5v-56c0-33.9 0-50.9-10.5-61.5zm-126.22 42.4c1.69-2.13 30.24-7.38 36.4-8.36v55c0 3.49.33 5.66-3.32 5.66l-34.49.07c-.1-2.87-.07-1.8-.07-4.74.03-41.66-.35-45.33 1.48-47.63zm87.65-11.14c-1.12.39-16.7 4.88-17 11.89l.07 71.25a30 30 0 0 0 -1.87 3.53c7.46 10.42 4.17 22.17-2.94 28-9.76 8-27.69 7.81-33.77-9.86-10.28 0-31.26 14.94-31.44 15.08-.53.5-1.19-.1-1.65-.73s-1.18-1.61-.56-2c0 0 13-11.24 12.27-12.06-2.57-3-10.47-10.72-10.42-13.73 0-.06-1-8.91-1.47-19.92h38.7c4.85 0 6.85-2.77 6.85-7.55v-65.2c0-.68.29-.81.69-.81h3.93c.3 0 .61.07.63.92v1.69h10.92c2.42 0 25-6.74 25-6.74 1.83-.37 3.3.38 3.7 1.44.69 1.79.2 4.17-1.64 4.8z"
            />
          </svg>
        </>
      );
    case ADD_ONS.CANTILEVER:
      return (
        <>
          <span>{label.CANTILEVER}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.CANTILEVER}</title>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <path d="m25 54v20h22v72h20v-72h108v-20z" fill="#fff" />
          </svg>
        </>
      );
    case ADD_ONS.REMOTE_CONTROL:
      return (
        <>
          <span>{label.REMOTE_CONTROL}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.REMOTE_CONTROL}</title>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <g transform="matrix(1.31304,0,0,1.30899,-78.9201,-5.47917)">
              <path
                d="M170.373,20.993C175.509,20.993 179.675,25.997 179.675,32.165L179.675,128.996C179.675,135.164 175.508,140.169 170.373,140.169L102.156,140.169C97.02,140.169 92.853,135.164 92.853,128.996L92.853,32.165C92.853,25.997 97.02,20.993 102.156,20.993L170.373,20.993Z"
                style={{ fillRule: 'nonzero' }}
                fill="#fff"
              />
            </g>
            <g transform="matrix(1.31304,0,0,1.30899,-92.6049,-4.02013)">
              <path
                d="M178.47,110.417L114.904,110.417C113.625,110.417 112.578,109.16 112.578,107.624L112.578,35.001C112.578,33.464 113.625,32.208 114.904,32.208L178.47,32.208C179.749,32.208 180.795,33.464 180.795,35.001L180.795,107.624C180.795,109.16 179.749,110.416 178.47,110.417Z"
                className="bg"
              />
            </g>
            <g transform="matrix(9.27478,0,0,9.1,22.6754,-86.6827)">
              <circle cx="8.337" cy="27.158" r="0.801" className="bg" />
            </g>
            <g transform="matrix(1.31304,0,0,1.30899,31.2539,-5.47917)">
              <path
                d="M52.357,78.996C49.751,78.996 47.639,81.075 47.639,83.639C47.639,86.203 49.751,88.282 52.357,88.282C54.962,88.282 57.074,86.203 57.074,83.639C57.074,81.075 54.962,78.996 52.357,78.996ZM70.255,71.124C60.076,62.264 44.625,62.274 34.458,71.124C33.849,71.654 33.829,72.575 34.408,73.136L37.449,76.09C37.979,76.605 38.832,76.64 39.396,76.16C46.81,69.852 57.919,69.866 65.316,76.16C65.88,76.64 66.733,76.606 67.263,76.09L70.305,73.136C70.884,72.575 70.864,71.653 70.255,71.124ZM80.167,61.256C64.521,47.013 40.186,47.018 24.546,61.256C23.957,61.792 23.946,62.698 24.515,63.254L27.538,66.206C28.081,66.736 28.953,66.748 29.517,66.239C42.404,54.62 62.308,54.617 75.197,66.239C75.761,66.748 76.633,66.735 77.175,66.206L80.199,63.254C80.767,62.698 80.756,61.792 80.167,61.256Z"
                style={{ fillRule: 'nonzero' }}
                fill="#fff"
              />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.SIDE_BY_SIDE:
      return (
        <>
          <span>{label.SIDE_BY_SIDE}</span>
          <svg
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.SIDE_BY_SIDE}</title>
            <symbol id="a" viewBox="0 0 70 46">
              <path d="m0 0h70v46h-70z" fill="#fff" />
            </symbol>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <use height="46" transform="translate(25 77)" width="70" xlinkHref="#a" />
            <use height="46" transform="translate(105 77)" width="70" xlinkHref="#a" />
          </svg>
        </>
      );
    case ADD_ONS.SIDE_BY_SIDE_RECT:
      return (
        <>
          <span>{label.SIDE_BY_SIDE_RECT}</span>
          <svg
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.SIDE_BY_SIDE_RECT}</title>
            <symbol id="a" viewBox="0 0 70 46">
              <path d="m0 0h70v46h-70z" fill="#fff" />
            </symbol>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <use height="46" transform="translate(25 77)" width="70" xlinkHref="#a" />
            <use height="46" transform="translate(105 77)" width="70" xlinkHref="#a" />
          </svg>
        </>
      );
    case ADD_ONS.SIDE_BY_SIDE_RHOM:
      return (
        <>
          <span>{label.SIDE_BY_SIDE_RHOM}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.SIDE_BY_SIDE_RHOM}</title>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <g fill="#fff">
              <path d="m48.558 77h58.678l-26.559 46h-58.677z" />
              <path d="m119.558 77h58.678l-26.559 46h-58.677z" />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.HANDLES:
      return (
        <>
          <span>{label.HANDLES}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.HANDLES}</title>
            <path
              className="bg"
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
              }}
              d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
            />
            <path
              d="m66 55.625 15.85907 15.8h-12.98828a10.00341 10.00341 0 0 0 -9.54077-7h-31.33002a10 10 0 0 0 -10 10v3.33a10 10 0 0 0 10 10h31.33a10.00341 10.00341 0 0 0 9.54077-7h22.35323l42.82953 42.67h-32.30353a9.995 9.995 0 0 0 -9.42-6.67h-31.33a10 10 0 0 0 -10 10v3.33a10 10 0 0 0 10 10h31.33a9.996 9.996 0 0 0 9.62848-7.33h41.46l11.66345 11.62h25.91807v-88.75z"
              fill="#fff"
            />
          </svg>
        </>
      );
    case ADD_ONS.TEMP_CONTROL:
      return (
        <>
          <span>{label.TEMP_CONTROL}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.TEMP_CONTROL}</title>
            <g
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 2,
              }}
            >
              <path
                className="bg"
                d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
              />
              <path
                d="m122.5 114.738c4.667 5.289 7.5 12.233 7.5 19.841 0 16.569-13.43 30-30 30-.07 0-.143 0-.213-.001-16.477-.114-29.871-13.678-29.787-30.155.039-7.547 2.865-14.433 7.5-19.685v-47.659c0-12.426 10.074-22.5 22.5-22.5s22.5 10.074 22.5 22.5zm-35.625-7.096v10.641c-2.573 2.916-7.456 7.566-7.5 16.187-.058 11.319 9.162 20.655 20.477 20.733l.148.001c11.373 0 20.625-9.253 20.625-20.625 0-8.711-4.958-13.415-7.5-16.296v-51.204c0-7.237-5.888-13.125-13.125-13.125-6.266 0-11.52 4.413-12.818 10.294h3.16c.938 0 1.698.76 1.698 1.697s-.76 1.697-1.698 1.697h-3.467v6.606h3.467c.938 0 1.698.76 1.698 1.697s-.76 1.697-1.698 1.697h-3.467v6.606h3.467c.938 0 1.698.76 1.698 1.697s-.76 1.697-1.698 1.697h-3.467v6.606h3.467c.938 0 1.698.76 1.698 1.697s-.76 1.697-1.698 1.697h-3.467v6.606h3.467c.938 0 1.698.76 1.698 1.697s-.76 1.697-1.698 1.697zm26.25 26.937c0 7.249-5.876 13.125-13.125 13.125s-13.125-5.876-13.125-13.125c0-5.236 3.066-9.754 7.5-11.86v-27.515c0-3.107 2.518-5.625 5.625-5.625s5.625 2.518 5.625 5.625v27.515c4.434 2.106 7.5 6.624 7.5 11.86z"
                fill="#fff"
                fillRule="nonzero"
                transform="matrix(1.25 0 0 1.25 -25 -30.7236)"
              />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.TIMER_ALARM:
      return (
        <>
          <span>{label.TIMER_ALARM}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.TIMER_ALARM}</title>
            <g
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 2,
              }}
            >
              <path
                className="bg"
                d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
              />
              <path
                d="m256 64c-123.74 0-224 100.29-224 224-.023 48.331 15.69 95.381 44.75 134l-40.1 40.09c-3 3-4.688 7.073-4.688 11.315s1.688 8.315 4.688 11.315l22.63 22.62c6.206 6.202 16.414 6.202 22.62 0l40.1-40.12c79.117 59.552 188.883 59.552 268 0l40.1 40.09c3 3 7.073 4.688 11.315 4.688s8.315-1.688 11.315-4.688l22.62-22.62c3-3 4.688-7.073 4.688-11.315s-1.688-8.315-4.688-11.315l-40.14-40.06c29.074-38.614 44.8-85.664 44.79-134 0-123.71-100.3-224-224-224zm0 400c-96.551 0-176-79.449-176-176s79.449-176 176-176 176 79.449 176 176-79.449 176-176 176zm-160-464c-52.664 0-96 43.336-96 96 .074 18.199 5.386 35.998 15.3 51.26l145.9-121.58c-17.696-16.496-41.008-25.678-65.2-25.68zm184 292.47v-124.47c0-4.389-3.611-8-8-8h-32c-4.389 0-8 3.611-8 8v132.16c-.006 9.717 4.414 18.927 12 25l64.54 51.57c1.678 1.275 3.769 1.887 5.87 1.72 2.103-.237 4.028-1.298 5.35-2.95l20-25c1.142-1.421 1.765-3.19 1.765-5.013 0-2.434-1.111-4.74-3.015-6.257zm136-292.47c-24.182.005-47.485 9.179-65.18 25.66l145.89 121.57c9.902-15.256 15.211-33.042 15.29-51.23 0-52.664-43.336-96-96-96z"
                fill="#fff"
                fillRule="nonzero"
                transform="matrix(.292969 0 0 .292969 25 25)"
              />
            </g>
          </svg>
        </>
      );
    case ADD_ONS.WATER_COOL_AIR_PURGE:
      return (
        <>
          <span>{label.WATER_COOL_AIR_PURGE}</span>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            aria-labelledby="title"
          >
            <title>{label.WATER_COOL_AIR_PURGE}</title>
            <g
              style={{
                clipRule: 'evenodd',
                fillRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 2,
              }}
            >
              <path
                className="bg"
                d="m0 72c0-33.9 0-50.9 10.5-61.5 10.6-10.5 27.6-10.5 61.5-10.5h56c33.9 0 50.9 0 61.5 10.5 10.5 10.6 10.5 27.6 10.5 61.5v56c0 33.9 0 50.9-10.5 61.5-10.6 10.5-27.6 10.5-61.5 10.5h-56c-33.9 0-50.9 0-61.5-10.5-10.5-10.6-10.5-27.6-10.5-61.5z"
              />
              <path
                d="m163.24 153.453c-6.657-.39-13.02-3.02-17.646-7.368-1.332-1.25-3.227-1.25-4.559.026-9.861 9.347-28.658 9.451-38.767-.026-1.332-1.25-3.227-1.25-4.558.026-9.862 9.347-28.659 9.451-38.768-.026-1.331-1.25-3.227-1.224-4.558.026-4.558 4.322-10.899 6.952-17.624 7.342-.97.053-1.737.938-1.737 2.057v6.166c0 1.172.857 2.161 1.873 2.109 7.288-.39 14.283-2.968 19.812-7.264 12.14 9.399 31.411 9.321 43.326 0 12.118 9.399 31.411 9.321 43.326 0 5.551 4.296 12.546 6.874 19.767 7.264 1.016.052 1.873-.937 1.873-2.109v-6.166c-.023-1.119-.79-2.004-1.76-2.057zm0-29.781c.97.052 1.737.937 1.737 2.057v6.166c0 1.171-.857 2.161-1.873 2.109-7.22-.391-14.216-2.969-19.767-7.265-11.915 9.322-31.208 9.4-43.326 0-11.914 9.322-31.185 9.4-43.326 0-5.528 4.296-12.523 6.874-19.812 7.265-1.016.052-1.873-.938-1.873-2.109v-6.166c0-1.12.767-2.005 1.738-2.057 6.724-.391 13.088-3.02 17.646-7.343 1.331-1.249 3.227-1.275 4.558-.026 10.109 9.478 28.906 9.374 38.768.026 1.331-1.275 3.226-1.275 4.558-.026 10.109 9.478 28.906 9.374 38.767.026 1.332-1.275 3.227-1.275 4.559-.026 4.626 4.349 10.989 6.978 17.646 7.369zm-91.989-33.366c-.039-5.818 7.245-8.171 9.551-2.356 1.933 4.874 8.474 2.165 7.645-3.112-.321-2.045-2.066-3.798-4.203-3.846-6.064-.046-22.129.076-28.193-.002-1.903-.073-3.55-1.703-3.624-3.624-.015-1.164-.151-2.353.227-3.379.512-1.393 1.896-2.381 3.397-2.439 6.044-.078 22.089-.001 28.133-.001 7.054.05 13.468 6.14 13.728 13.232.225 6.108-3.957 11.899-10.062 13.77-7.384 2.264-15.429-.835-16.599-8.243zm73.616 2.476c8.667-.174 15.727-9.776 12.807-18.236-1.825-5.289-7.077-9.123-12.787-9.246-14.122-.1-28.246-.179-42.368 0-1.903.073-3.551 1.703-3.624 3.624-.015 1.165-.151 2.354.226 3.379.513 1.394 1.896 2.382 3.398 2.44 14.099.183 28.204-.318 42.3.003 3.897.147 6.206 7.254.887 8.475-2.313.531-4.433-1.144-5.314-3.508-2.66-4.017-10.205-.992-8.569 4.282 1.81 5.834 6.604 8.834 13.044 8.787zm-30.876-59.569c8.666.174 15.726 9.777 12.806 18.237-1.825 5.288-7.076 9.123-12.787 9.245-14.122.101-54.572.18-68.694 0-1.903-.072-3.55-1.702-3.624-3.624-.015-1.164-.151-2.353.227-3.379.512-1.393 1.896-2.382 3.397-2.439 14.099-.183 54.53.317 68.627-.003 3.896-.147 6.206-7.254.887-8.476-2.314-.531-4.433 1.144-5.314 3.508-2.661 4.017-10.205.992-8.57-4.282 1.81-5.834 6.605-8.834 13.045-8.787z"
                fill="#fff"
                fillRule="nonzero"
              />
            </g>
          </svg>
        </>
      );
    default:
      return null;
  }
};

const AddOn = ({ options, label, themeColour }) => (
  <div className="product-options">
    {options.map(option => (
      <div className={`option ${themeColour}`} key={option}>
        {addOnsSVG(option, label)}
      </div>
    ))}
  </div>
);

AddOn.defaultProps = {
  options: [],
  label: {},
  themeColour: '',
};

AddOn.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.shape({
    common: PropTypes.instanceOf(Object),
  }),
  themeColour: PropTypes.string,
};

export default AddOn;
